import { wsURL } from "./api";

// src/utils/WebSocketManager.ts
class WebSocketManager {
  private ws: WebSocket | null = null;
  private reconnectAttempts: number = 0;
  private maxReconnectAttempts: number = 5;
  private reconnectInterval: number = 3000;
  private onMessageCallback: (data: any) => void = () => {};
  private onErrorCallback: (message: string) => void = () => {};
  private isConnecting: boolean = false;

  connect(token: string) {
    if (this.isConnecting || (this.ws && this.ws.readyState === WebSocket.OPEN)) {
      console.log('WebSocket 已连接或正在连接，跳过重复连接');
      return;
    }

    this.isConnecting = true;
    // this.ws = new WebSocket(`ws://localhost:8000/ws/report/?token=${token}`);
    this.ws = new WebSocket(`${wsURL}ws/report/?token=${token}`);

    this.ws.onopen = () => {
      console.log('WebSocket connected');
      this.reconnectAttempts = 0;
      this.isConnecting = false;
    };

    this.ws.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        console.log('WebSocket message received:', data);
        this.onMessageCallback(data);
      } catch (error) {
        console.error('Failed to parse WebSocket message:', error);
        this.onErrorCallback('消息解析失败');
      }
    };

    this.ws.onerror = (error) => {
      console.error('WebSocket error:', error);
      this.onErrorCallback('WebSocket 连接错误');
      this.reconnect(token);
    };

    this.ws.onclose = (event) => {
      console.log('WebSocket disconnected:', event);
      if (!event.wasClean && this.reconnectAttempts < this.maxReconnectAttempts) {
        this.reconnect(token);
      }
    };
  }

  reconnect(token: string) {
    if (this.reconnectAttempts >= this.maxReconnectAttempts || this.isConnecting) {
      console.log(`最大重连尝试次数 ${this.maxReconnectAttempts} 已达，停止重连`);
      this.onErrorCallback('WebSocket 重连失败，请检查后端服务');
      return;
    }

    this.reconnectAttempts++;
    console.log(`尝试第 ${this.reconnectAttempts}/${this.maxReconnectAttempts} 次重连`);
    setTimeout(() => {
      this.connect(token);
    }, this.reconnectInterval);
  }

  send(data: string) {
    if (!this.ws || this.ws.readyState !== WebSocket.OPEN) {
      console.warn('WebSocket 未连接，无法发送数据:', data);
      this.onErrorCallback('WebSocket 未连接，请稍后重试');
      return;
    }

    try {
      this.ws.send(data);
      console.log('WebSocket message sent:', new Date().toLocaleTimeString());
      // console.log('WebSocket message sent:', data);
    } catch (error) {
      console.error('Failed to send WebSocket message:', error);
      this.onErrorCallback('发送数据失败');
    }
  }

  setOnMessageCallback(callback: (data: any) => void) {
    this.onMessageCallback = callback;
  }

  setOnErrorCallback(callback: (message: string) => void) {
    this.onErrorCallback = callback;
  }

  close(manualClose?: boolean) {
    if (this.ws) {
      this.ws.close();
      if (!manualClose) {
        this.onErrorCallback('WebSocket 已断开');
      }
      this.ws = null;
      this.reconnectAttempts = 0;
      this.isConnecting = false;
    }
  }
}

export default WebSocketManager;